import { render } from "./placeholders.vue?vue&type=template&id=18db4b0a"
import script from "./placeholders.vue?vue&type=script&lang=js"
export * from "./placeholders.vue?vue&type=script&lang=js"

import exportComponent from "/Users/brunocarvalho/Projetos/admin-colegio-encanto-juvenil/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__